// Mock data for the brand setup screen. The form starts empty; the preview
// falls back to `previewSample` for anything still blank, so the document on
// the right always reads as a finished page instead of a skeleton.

import { BrandDetails } from "../types/brand.types";

export const emptyBrandDetails: BrandDetails = {
  fullName: "",
  brandName: "",
  logo: null,
  phone: "",
  whatsapp: "",
  whatsappSameAsPhone: false,
  email: "",
  address: "",
  state: "",
  city: "",
  pincode: "",
  accountHolder: "",
  accountNumber: "",
  bankName: "",
  ifsc: "",
  upiNumber: "",
  upiId: "",
  paymentQr: null,
};

/** Upload rules, quoted in the hint under each picker and enforced by it. */
export const MAX_UPLOAD_BYTES = 1024 * 1024;

/**
 * Longest side, in pixels. A logo or a QR never needs to be this big, and a
 * camera-roll photo dropped in by mistake usually is — the ceiling is what
 * stops one being carried into every invoice and meal plan.
 */
export const MAX_IMAGE_DIMENSION = 4096;

/**
 * Raster only. SVG is deliberately not on the list: it is an XML document
 * rather than an image, it can carry `<script>`, and these files are served
 * to clients — so it is rejected however it is offered.
 *
 * `image/jpg` is not a real media type, but some Windows registries hand it to
 * the file picker for a `.jpg`; it is the same JPEG either way, and leaving it
 * off would turn away valid files.
 */
export const ACCEPTED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];
export const ACCEPTED_IMAGE_ATTR = ".png,.jpg,.jpeg,.webp";

/** Stand-ins used by the preview until the matching field is filled in. */
export const previewSample = {
  fullName: "Riya Roy",
  brandName: "Nutro diet studio",
  /** The slug form, which is what the public page address is built from. */
  handle: "riya",
  phone: "+91 9876543210",
  email: "hello@dietstudion.com",
  address: "102, Skylark, Andheri West,",
  cityLine: "Mumbai Maharashtra, 40064",
  /** The same person as `fullName` — an account is held in a name, not a
   *  brand, and a specimen that split the two would teach the wrong thing. */
  accountHolder: "Riya Roy",
  accountNumber: "5648920272",
  bankName: "State bank of India",
  ifsc: "SBIN00001",
  upiNumber: "+91 9876543210",
  upiId: "9876543210@kotakbank",
};

/** The invoice preview is a specimen document, not a real bill. */
export const invoiceSample = {
  number: "#06/002",
  dateIssued: "5 July 2026",
  billedTo: {
    name: "Ajay Kumar",
    address: "1204, Galaxy, SV Road Malad West,",
    cityLine: "Mumbai Maharashtra, 40064",
  },
  lineItem: {
    planName: "Weight loss plan",
    duration: "1 month",
    amount: "₹1499",
  },
  payableAmount: "₹ 1499",
};

export const mealPlanSample = {
  clientName: "Ajay Kumar",
  planId: "NMP004",
  startDate: "01 July, 2026",
  goal: "Weight loss",
};
